import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import embed from "vega-embed";

const Container = styled.div`
  width: 100%;
  min-height: 300px;
  margin: 16px 0;
`;

const ErrorText = styled.p`
  font-size: 13px;
  color: #ef4444;
  margin: 4px 0;
`;

export default function ChartBlock({ chartSpec }) {
  const containerRef = useRef(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!containerRef.current || !chartSpec) return;

    let isMounted = true;
    let vegaResult = null;

    const run = async () => {
      try {
        const spec = JSON.parse(chartSpec);
        if (!spec || typeof spec !== "object" || Array.isArray(spec)) {
          throw new Error("Invalid chart spec: expected an object");
        }
        spec.width = "container";
        spec.autosize = { type: "fit", contains: "padding" };

        if (!spec.padding) {
          spec.padding = { top: 40, right: 24, bottom: 20, left: 8 };
        }

        const cfg = spec.config || {};
        spec.config = {
          ...cfg,
          view: { step: 72, ...(cfg.view || {}) },
          axis: { labelFontSize: 12, titleFontSize: 13, ...(cfg.axis || {}) },
          axisY: { labelLimit: 160, ...(cfg.axisY || {}) },
          axisX: { labelFontSize: 12, ...(cfg.axisX || {}) },
        };

        const r = await embed(containerRef.current, spec, {
          actions: false,
          renderer: "svg",
        });

        if (isMounted) {
          vegaResult = r;
        } else {
          r.finalize();
        }
      } catch {
        if (isMounted) setHasError(true);
      }
    };

    run();

    return () => {
      isMounted = false;
      vegaResult?.finalize();
    };
  }, [chartSpec]);

  if (hasError) {
    return (
      <ErrorText data-testid="chart-error">
        Chart could not be rendered.
      </ErrorText>
    );
  }

  return <Container ref={containerRef} data-testid="chart-container" />;
}
